import * as Yup from "yup";

import { isValidPhoneForIsd } from "constants/phoneConfig";
import {
  LOGIN_FIELD_NAMES,
  LOGIN_PASSWORD_MIN_LENGTH,
  LOGIN_VALIDATION_MESSAGES,
} from "./constants/loginContent";

export const createLoginValidationSchema = (getIsdCodeForCountry) =>
  Yup.object({
    [LOGIN_FIELD_NAMES.COUNTRY_CODE]: Yup.string().required(
      LOGIN_VALIDATION_MESSAGES.COUNTRY_REQUIRED
    ),
    [LOGIN_FIELD_NAMES.MOBILE]: Yup.string()
      .required(LOGIN_VALIDATION_MESSAGES.MOBILE_REQUIRED)
      .test(
        "isd-phone",
        LOGIN_VALIDATION_MESSAGES.MOBILE_INVALID,
        function validateMobileForIsd(value) {
          const countryCode = this.parent[LOGIN_FIELD_NAMES.COUNTRY_CODE];
          const isdCode = getIsdCodeForCountry?.(countryCode) || "";
          return isValidPhoneForIsd(value, isdCode);
        }
      ),
    [LOGIN_FIELD_NAMES.PASSWORD]: Yup.string()
      .required(LOGIN_VALIDATION_MESSAGES.PASSWORD_REQUIRED)
      .min(
        LOGIN_PASSWORD_MIN_LENGTH,
        LOGIN_VALIDATION_MESSAGES.PASSWORD_MIN_LENGTH
      ),
  });
